// Logo Numwave : l'icône "vague N" (public/lonumwave.png) + le mot-marque
// « NUM » (sombre) « WAVE » (vert), comme le format choisi.
export default function WhaZagoLogo({ size = "md", tone = "light" }) {
  const isLarge = size === "lg";
  const darkTone = tone === "dark";
  const logo = `${process.env.PUBLIC_URL || ""}/lonumwave.png`;

  return (
    <div className="inline-flex items-center gap-2.5" data-testid="whazago-logo">
      <img
        src={logo}
        alt="Numwave"
        className={isLarge ? "h-11 w-11" : "h-9 w-9"}
        style={{ objectFit: "contain", display: "block" }}
      />
      <p
        className={`font-heading font-extrabold tracking-tight ${isLarge ? "text-2xl" : "text-lg sm:text-xl"}`}
        data-testid="whazago-logo-text"
      >
        <span className={darkTone ? "text-white" : "text-[#0f1828]"}>NUM</span>
        <span className="text-[#4FA827]">WAVE</span>
      </p>
    </div>
  );
}
